export default {
  meta: {
    title: '踩点宝' // 加盟商管理-标准版
  }
};
